var _path, _path2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAncientgreek(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_44939_319695)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_44939_319695)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_44939_319695",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -5,
    y: -1,
    width: 34,
    height: 26
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.58-.5H-4.665v24.933H28.58V-.5z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_44939_319695)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_44939_319695",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -5,
    y: -1,
    width: 34,
    height: 26
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.58-.567H-4.665v25H28.58v-25z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_44939_319695)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.58-.567H-4.665v25H28.58v-25z",
    fill: "#185FAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.33 17.332s-.028-.056-.075-.107H5.252v.537H4.82v.755H15.01l.027-.398c.32-.19.283-.787.283-.787M9.581 12.595l-.027-.06-.514-.273v3.426h-.163v1.18h1.83v-1.18h-.135v-2.625s-.759.056-.967-.463M17.099 8.508H5.576v.68h11.523v-.68zM5.075 8.258H17.27c.237 0 .265-.107.065-.237l-5.798-3.763a.718.718 0 00-.723 0L5.015 8.02c-.2.13-.167.237.07.237h-.01zm6.081-3.45h.046l4.322 2.806H6.83l4.325-2.805zM7.724 10.55V9.368H5.895v1.18h.144v5.14h-.144v1.18h1.829v-1.18h-.176v-5.14h.176zM13.611 15.688a2.776 2.776 0 01-.296-2.097 2.842 2.842 0 01-.801-1.852c-.084-1.43 1.042-1.565 1.26-1.574v-.796h-1.812v1.176h.162v5.139h-.162v1.18h1.853v-.972c-.056-.07-.102-.139-.148-.208l-.056.004zM16.802 9.369H14.973v.537h1.829v-.537zM14.023 15.744v-.209h-.152c.045.073.096.143.152.209zM18.91 15.637h.217v.37l.12-.12v-.333h-.337v.083z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.815 14.29v-.231h-.223v-.306c-.04.175-.06.353-.06.532l.283.005z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.653 13.484a1.896 1.896 0 00-.08.264h.561v.542h.315v-.232h-.222v-.31h.565v.542h.31v-.232h-.222v-.31h.565v.542h.315v-.232h-.222v-.31h.56v.542h.315v-.232h-.223v-.31h.566v.542h.3v-.232h-.222v-.31h.565v.542h.315v-.232h-.194v-.31h.56v.542h.315v-.232h-.222v-.31h.565v.542h.31v-.232h-.222v-.31h.546v.542h.315v-.232h-.227v-.31h.375a2.51 2.51 0 00-.083-.264 2.643 2.643 0 00.797-2.356c-.186-.727-1.306-.727-1.325-.727h-.56v-.26H14.74v.26h-.556c-.023 0-1.14 0-1.324.727a2.645 2.645 0 00.796 2.356h-.004zm4.478-2.75h1.093s.88 0 .996.463a2.315 2.315 0 01-.62 1.959 2.242 2.242 0 00-.927-.843.884.884 0 01-.787-.926.982.982 0 01.25-.671l-.005.018zm-4.946.463c.116-.463.99-.463 1-.463h1.089a.981.981 0 01.25.672.884.884 0 01-.783.926 2.231 2.231 0 00-.926.838 2.314 2.314 0 01-.625-1.954M19.048 16.072h-.44v-.537h-.343v.102h.223v.463h-.533v-.565h-.342v.102h.222v.463h-.533v-.565h-.343v.102h.218v.463h-.537v-.565h-.338v.102h.222v.463h-.537v-.565h-.32v.102h.223v.463h-.556v-.565h-.338v.102h.208v.463h-.523v-.565h-.338v.102h.222v.463h-.213c.463.417 1.024.704 1.325 1.167a1.339 1.339 0 01-.283 1.005v.305h2.663v-.306a1.342 1.342 0 01-.282-1.004c.386-.445.83-.838 1.32-1.167",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.576 13.86v.083h.222v.463h-.537v-.546h-.352v.083h.223v.463h-.524v-.546h-.338v.083h.218v.463h-.533v-.546h-.338v.083h.218v.463h-.533v-.546h-.343v.083h.218v.463h-.537v-.546h-.338v.083h.222v.463h-.537v-.546h-.32v.083h.223v.463h-.556v-.546h-.338v.083h.208v.463h-.523v-.546h-.338v.083h.222v.463h-.537v-.546h-.338v.083h.222v.463h-.39c.006.137.023.273.052.407.047.215.129.422.24.611h.339v.463l.092.093h.223v-.232h-.236v-.305h.56v.518h.315v-.231h-.227v-.306h.565v.537h.315v-.231h-.222v-.306h.56v.537h.315v-.231h-.223v-.306h.566v.537h.3v-.231h-.222v-.306h.565v.537h.315v-.231h-.194v-.306h.56v.537h.315v-.231h-.222v-.306h.565v.537h.31v-.231h-.222v-.306h.546v.32l.093-.111v-.209h.13c.111-.19.19-.398.231-.615.061-.313.064-.635.01-.95h-.26z",
    fill: "#fff"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_44939_319695"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_44939_319695"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(-4.665 -.5)",
    d: "M0 0h33.245v25H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAncientgreek);
export default __webpack_public_path__ + "static/media/ancientgreek.0156363456371dd2230b4f30cc16213b.svg";
export { ForwardRef as ReactComponent };